// eslint-disable-next-line no-console
console.log('worker has started')
